import { render, staticRenderFns } from "./SpecialitiesList.vue?vue&type=template&id=2c1572c7&"
import script from "./SpecialitiesList.vue?vue&type=script&lang=js&"
export * from "./SpecialitiesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports